import Main from './Main'
import Edit from './Edit'

export default {
  Main,
  Edit
}



// WEBPACK FOOTER //
// ./src/components/User/User/index.js